import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import AI from "./pages/services/AI&IA";
import DST from "./pages/services/DST";
import GCC from "./pages/services/GCC";
import CSC from "./pages/services/CSC";
import PEPD from "./pages/services/PE&PD";
import SWS from "./pages/services/SWS";
import RWG from "./pages/industries/RWG";
import GPS from "./pages/industries/GPS";
import HLS from "./pages/industries/HLS";
import LSC from "./pages/industries/LSC";
import FS from "./pages/industries/FS";
import CaseStudies from "./pages/CaseStudies";
import Careers from "./pages/Careers";
import Clients from "./pages/Clients";
import Services from "./pages/Service";
import Industries from "./pages/Industrie";
import ScrollToTop from "./components/ScrollToTop";
import WholesaleGrocery from "./pages/case-studies/Wholesale Grocery Leader – AI Forecasting";
import InsuranceClient from "./pages/case-studies/Insurance Client – Claims Automation";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Employee from "./pages/Employee";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Hire from "./pages/careers/Hire";
import Form from "./pages/careers/form";
import CaseStudyDetails from "./pages/case-studies/CaseStudyDetails";
import Products from "./pages/products/polytxl";
import BlogGridPage from "./pages/BlogGridPage";
import BlogDetail from "./pages/blog/BlogDetail";
import OracleERPConsulting from "./pages/blog/OracleERPConsulting";
import BestITConsulting from "./pages/blog/BestITConsulting";
import DigitalTransformation from "./pages/blog/DigitalTransformation";
import ExpandingGCCOperations from "./pages/blog/ExpandingGCCOperations";
import CybersecurityCompliance from "./pages/blog/CybersecurityCompliance";
import ITStaffing from "./pages/blog/ITStaffing";
import AIEnterprise from "./pages/blog/AIEnterprise";
import DataProtection from "./pages/blog/DataProtection";

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Services/GCC" element={<GCC />} />
        <Route path="/Services/AI" element={<AI />} />
        <Route path="/Services/DST" element={<DST />} />
        <Route path="/Services/CSC" element={<CSC />} />
        <Route path="/Services/PE&PD" element={<PEPD />} />
        <Route path="/Services/SWS" element={<SWS />} />
        <Route path="/Industries/RWG" element={<RWG />} />
        <Route path="/Industries/GPS" element={<GPS />} />
        <Route path="/Industries/HLS" element={<HLS />} />
        <Route path="/Industries/LSC" element={<LSC />} />
        <Route path="/Industries/FS" element={<FS />} />
        <Route path="/Employee" element={<Employee />} />
        <Route path="/CaseStudies" element={<CaseStudies />} />
        <Route path="/CaseStudies/Details" element={<CaseStudyDetails />} />
        <Route path="/CaseStudies/WSGL-AI" element={<WholesaleGrocery />} />
        <Route path="/CaseStudies/IC-CA" element={<InsuranceClient />} />
        <Route path="/Careers" element={<Careers />} />
        <Route path="/Clients" element={<Clients />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Industries" element={<Industries />} />
        <Route path="/TermsofService" element={<TermsOfService />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/Careers/Hire" element={<Hire />} />
        <Route path="/Apply" element={<Form />} />
        <Route path="/products/polytxl" element={<Products />} />
        <Route path="/blogs" element={<BlogGridPage />} />
        <Route path="/blog/oracle-erp-consulting-new-jersey-guide"element={<OracleERPConsulting />}/>
        <Route path="/blog/best-it-consulting-company-hyderabad"element={<BestITConsulting />}/>
        <Route
  path="/blog/digital-transformation-companies-in-hyderabad"
  element={<DigitalTransformation />}
/>
<Route
  path="/blog/expanding-gcc-operations-in-hyderabad"
  element={<ExpandingGCCOperations />}
/>
<Route
  path="/blog/cybersecurity-compliances-companies-in-hyderabad"
  element={<CybersecurityCompliance />}
/>
<Route
  path="/blog/it-staffing-companies-in-hyderabad"
  element={<ITStaffing />}
/>
<Route
  path="/blog/ai-enterprise-digital-transformation-india-new-jersey-2026"
  element={<AIEnterprise />}
/>
<Route
  path="/blog/data-protection-laws-hyderabad-it-teams-us-clients"
  element={<DataProtection />}
/>
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
